import gsap from 'gsap';
import {$style} from '../../../helpers/style';
import {$dom} from '../../../helpers/dom';
import variables from '../../../variables';
import SmoothScrollbar from 'smooth-scrollbar';

const {
	offset
} = $style;

const {
	exist,
	get,
	getAll
} = $dom;

export default function createArticleMobileNav() {

	const
		wrapSelector = '.js-article-nav-wrap',
		navSelector = '.js-article-nav',
		linkSelector = '.js-article-nav-link'
	;

	if (exist(
		[
			wrapSelector,
			navSelector
		]
	)) {
		const links = getAll(linkSelector);
		const lastLink = links[links.length - 1];

		gsap.set(wrapSelector, {clearProps: 'marginLeft,overflow,width'});
		gsap.set(navSelector, {paddingLeft: 'paddingLeft'});
		gsap.set(lastLink, {clearProps: 'paddingRight'});
		const ww = variables.windowWidth;

		if (ww < variables.breakpoints.md) {

			const
				wrapInitWidth = gsap.getProperty(get(wrapSelector), 'width'),
				wrapLeftOffset = offset(wrapSelector).left,
				wrapRightOffset = ww - (wrapLeftOffset + wrapInitWidth)
			;

			gsap.set(wrapSelector, {
				marginLeft: - wrapLeftOffset,
				width: wrapInitWidth + wrapRightOffset + wrapLeftOffset + 'px',
				overflow: 'hidden'
			});

			gsap.set(navSelector, {paddingLeft: wrapLeftOffset});
		}

	}


}
